import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumnWideAdd"><Path d="M2 4V20H12.75V5.5H20.5V11H22V4H2Z" fill="currentColor"/><Path d="M19.75 13H18.25V16.25H15V17.75H18.25V21H19.75V17.75H23V16.25H19.75V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideAdd;
